import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/junli/work/fun/hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { useSessionStorage } from "../../index";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "usesessionstorage"
    }}>{`useSessionStorage`}</h1>
    <p>{`sessionStorage hooks`}</p>
    <hr />
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const [
  value,
  setValue,
] = useSessionStorage(
  key: string,
  initialValue?: InitialValue<T>,
);
`}</code></pre>
    <h3 {...{
      "id": "key"
    }}>{`key`}</h3>
    <p>{`localStorage的key值`}</p>
    <h3 {...{
      "id": "initialvalue"
    }}>{`initialValue`}</h3>
    <p>{`初始值`}</p>
    <hr />
    <h2 {...{
      "id": "demo"
    }}>{`DEMO`}</h2>
    <Playground __position={2} __code={'() => {\n  if (typeof window == \'undefined\') {\n    return null\n  }\n  const [state, setState] = useSessionStorage(\'s-storage-key\', \'value1\')\n  return (\n    <div>\n      <div>value: {state}</div>\n      <button onClick={() => setState(\'value2\')}>set value2</button>\n      <button onClick={() => setState(\'value3\')}>set value3</button>\n      <button onClick={() => setState()}>clear</button>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      useSessionStorage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        if (typeof window == 'undefined') {
          return null;
        }

        const [state, setState] = useSessionStorage('s-storage-key', 'value1');
        return <div>
        <div>value: {state}</div>
        <button onClick={() => setState('value2')}>set value2</button>
        <button onClick={() => setState('value3')}>set value3</button>
        <button onClick={() => setState()}>clear</button>
      </div>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      